module.exports = __webpack_public_path__ + "img/technicalSupervision_checked.9c62aca9.png";